var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error)?_c('hh-msg-display',{attrs:{"message":_vm.error,"type":"error"}}):(_vm.hasSlot)?_c('hh-msg-display',{attrs:{"type":"error"}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }